export default __webpack_public_path__ + "8fc2d592694de184c8e513394a284abc.jpg";